module.exports = __webpack_public_path__ + "img/sc5_004.6b67d9f7.png";